// extracted by mini-css-extract-plugin
export default {"disabledDashboardLink":"styles_disabledDashboardLink__gqrxH"};